import {Modal} from 'react-bootstrap'

export const AddLabModal = (props: any) => {
  return (
    <Modal
      show={props.modalState}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.closeModal()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <div className='fs-3 fw-bold'>No Lab associated with this Product. Do you want to add Lab?</div>
        <div className='fs-3 fw-bold'></div>

      </Modal.Header>
      <Modal.Body className='container border-0' />
              
      <div className='ePulse-modal-content'>
  
        <div className='btn-row'>
          <button className='ePulse-btn-primary' type='button' onClick={() =>props.onCancel()}>Cancel</button>
       <button className='ePulse-btn-primary' type='button' onClick={() =>props.onDone()}>
        Add Lab
       </button>
        </div>
      </div>
    </Modal>
  )
}